"use client";

import { useState } from "react";
import dynamic from "next/dynamic";
import { Terminal } from "@/lib/icons";
import { useAuth } from "@/lib/auth-context";

const TerminalModal = dynamic(() => import("@/components/terminal-modal"), {
  ssr: false,
});

export default function TerminalButton() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="text-muted hover:text-accent transition-colors"
        title="Open terminal"
      >
        <Terminal />
      </button>
      {open && <TerminalModal open={open} onClose={() => setOpen(false)} />}
    </>
  );
}
